import { TypographyType, TextareaType, CellType } from "data/CellComponent";
import { Stack } from "@mui/joy";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import { ProgramContentType } from "data/BlockComponent";
import React, { memo } from "react";
import Cell from "../cell/Cell";

function Line({
  lineStr,
  lineIndex,
  taskKey,
  thoughtRecordKey,
  meditationRecordKey,
  activityRecordKey,
  data,
  setData,
  blockIndex,
  isLastLine,
  translationVersion,
  readonly,
  isShown,
  hasDivider,
  onAttemptEdit,
}: {
  lineStr: string;
  lineIndex: number;
  taskKey: string;
  thoughtRecordKey?: string;
  meditationRecordKey?: string;
  activityRecordKey?: string;
  data?: ProgramContentType[];
  setData: React.Dispatch<
    React.SetStateAction<ProgramContentType[] | undefined>
  >;
  blockIndex: number;
  isLastLine: boolean;
  translationVersion?: string;
  readonly: boolean;
  isShown: boolean;
  hasDivider?: boolean;
  onAttemptEdit?: () => void;
}) {
  const line: CellType[] = JSON.parse(lineStr);

  return (
    <div
      key={`${taskKey}_${blockIndex}_${lineIndex}`}
      className="flex gap-[10px] items-stretch w-full"
    >
      {line.map((cell, cellIndex) => (
        <Stack
          key={
            (cell.content as TextareaType)?.editorKey
              ? `${taskKey}_textarea_${
                  (cell.content as TextareaType).editorKey
                }`
              : `${taskKey}_${blockIndex}_${lineIndex}_${cellIndex}`
          }
          sx={{
            width: `${((cell.content as TypographyType)?.width || 1) * 100}%`,
            alignSelf: "stretch",

            mb: !isLastLine
              ? cell.type === "typography" &&
                (cell.content as TypographyType).isLabel
                ? "4px"
                : cell.type === "divider"
                ? 0
                : "12px"
              : 0,
            ...(hasDivider && {
              pb: "12px",
              borderBottomWidth: "1px",
              borderColor: "divider",
            }),
          }}
          className="flex justify-center"
        >
          <Cell
            type={cell.type}
            contentStr={JSON.stringify(cell.content)}
            blockIndex={blockIndex}
            lineIndex={lineIndex}
            cellIndex={cellIndex}
            taskKey={taskKey}
            thoughtRecordKey={thoughtRecordKey}
            meditationRecordKey={meditationRecordKey}
            activityRecordKey={activityRecordKey}
            data={data}
            setData={setData}
          translationVersion={translationVersion}
          readonly={readonly}
          isShown={isShown}
          onAttemptEdit={onAttemptEdit}
        />
        </Stack>
      ))}
    </div>
  );
}

export default memo(Line);
